import React from 'react';
import { useEffect} from 'react';
import { ProductCard } from "modules/product/components/productCard";
import {get_total_qty_per_prod} from "utils/cartUtils";
import { filterParam } from "modules/catalog/types/filters_params";

import { useCart } from "modules/cart/hooks/useCart";
import { CatalogResponse } from '../types/catalogResponse';
import { CursorPaginator, Paginator } from "modules/catalog/components/paginator";
import { ProductCatalogSkeleton } from './product-catalog-skeleton';
import { NoAuthError } from 'modules/authentication/components/no-auth-error';
import { AuthError } from 'modules/authentication/types/form-login-types';
import { GeneralError } from 'modules/main/components/general-error';


import { isDesktopSize } from 'utils/is-desktop';
import { useMediaQuery } from '@/hooks/use-media-query';

interface ProductCatalogProps extends React.HTMLAttributes<HTMLDivElement>{
    section:string,
    brand_filters:filterParam,
    tag_filters:filterParam
    currentPage:string | null,
    search_params:string
    isMobile?:boolean,
    data:CatalogResponse,
    error?:any,
    loading?:boolean
} 


export const ProductCatalog = React.forwardRef<HTMLDivElement,ProductCatalogProps>(({
    className,
    section,
    brand_filters,
    tag_filters,
    currentPage,
    search_params,
    data,
    ...props},ref) => {
    const isDesktop = useMediaQuery(isDesktopSize);

    const {addDeletefromCart,recalculatePrice,validating, cart} = useCart();
        

    const pages = data?.pages?? 0;


    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [currentPage,search_params]);  

    const ErrorComponent = (props.error instanceof AuthError) ? NoAuthError : GeneralError;

    return (           
        <>
        {(props.error)&&(<ErrorComponent/>)}
        {(props.loading)&&(<ProductCatalogSkeleton isMobile={props.isMobile}/>)}
        {(!props.loading && !props.error) &&    
        <div className="flex flex-col flex-1 p-2 text-sm gap-4">          
            <div className="flex flex-row flex-wrap gap-2 2xl:gap-4 justify-center">
                {
                data?.products?.map( (product, index) => {                        
                    return (
                        <ProductCard  key={index} 
                            product={product} 
                            addCallback={addDeletefromCart} 
                            recalculateCallBack={recalculatePrice}
                            validatingCallBack={validating}
                            inCart={get_total_qty_per_prod(product.id,cart)}
                            isDesktop={isDesktop}
                            />                      
                    );
                })}                        
            </div>
            <CursorPaginator search_params={search_params} 
                current={currentPage} 
                next={data?.next_page??null} />            
            {/* <Paginator pages={pages} search_params={search_params} currentPage={currentPage} isMobile={props.isMobile}/> */}
        </div>    
        }
        </>  
    );
})